'use strict';


export default class Connection extends Map
{
    constructor(total, pageInfo, list) {
        super(list);
        this._total = total;
        this._pageInfo = pageInfo;
        this._length = list.length;
    }

    total() {
        return this._total;
    }

    pageInfo() {
        return this._pageInfo;
    }

    count() {
        return this.size;
    }

    get length() {
        return this.size;
    }

    set length(length) {
    }

    toArray() {
        let arr = [];
        this.forEach((value) => { arr.push(value); });
        return arr;
    }

    filter(callback) {
        let arr = [];
        this.forEach(function(value, key, map){
            if( callback(value, key, map) == true ) {
                arr.push(value);
            }
        });

        return arr;
    }
}


// WEBPACK FOOTER //
// ./src/graphql/Connection.js